import { CardContent } from '@mui/material';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import React from 'react';
import useWebContext from '../../hooks/useWebContext';
import { ItAppLinkCard } from '../../ui-parts/ItAppLinkCard';
import { OutlinedCustomCard } from '../../ui-parts/OutlinedCustomCard';
import { HomeFileListItem, HomeLeftHeader, HomeMorePageLink, HomeNoContentBox } from './HomeUtils';
import { mediaQuery, useMediaQuery } from '../../hooks/useMediaQuery';

export const HomeMyFavoriteDocumentApplicationCard = ({ screenId, favoriteBoxFile, favoriteItApp, onPreview, apiRequest }) => {
  const { controlSettings, messageList, screenSettings } = useWebContext(screenId);
  const isPc = useMediaQuery(mediaQuery.pc);

  return (
    <OutlinedCustomCard sx={{ display: 'flex', flexDirection: 'column', height: '369px', overflowY: isPc ? 'visible' : 'auto' }}>
      <Grid container spacing={1} className="mt-0" sx={{ paddingBottom: "0px" }}>
        <Grid item xs={12} md={12} lg={6} >
          <HomeLeftHeader title={controlSettings.LabelList.lblMyFavoritesTitle} sx={{ fontWeight: "bolder", paddingTop: "0px" }} />
          <CardContent sx={{
            flex: 1, "&:last-child": {

              paddingTop: "0px",
              paddingLeft: "2px",
            }
          }} >
            {
              favoriteBoxFile.length > 0 ?
                <List disablePadding >
                  {favoriteBoxFile.map((item) => {
                    return (
                      <HomeFileListItem
                        screenId={screenId}
                        fileId={item.FileId}
                        fileName={item.NameDisp}
                        fileNameAbbMaxLength={screenSettings.FavoriteBoxFileNameMaxLength}
                        key={item.FileId}
                        extension={item.Extension}
                        onPreview={onPreview} />
                    )
                  })
                  }
                </List>
                :
                <HomeNoContentBox content={messageList.MyM_MSG_I_0008} />
            }
            <HomeMorePageLink listData={favoriteBoxFile} href='/MyM102/MyM202' displayContent={controlSettings.LabelList.lnkSeeAllFavorites} />
          </CardContent>
        </Grid>
        <Grid item xs={12} md={12} lg={6} sx={{ overflowX: isPc ? 'none' : 'auto' }} >
          <HomeLeftHeader title={controlSettings.LabelList.lblMyFavoriteITAppsTitle} sx={{ marginLeft: isPc ? "10px" : "2px", fontWeight: "bolder", paddingTop: "0px" }} />
          <CardContent sx={{
            flex: 1, "&:last-child": {

              paddingTop: "0px",
              paddingBottom: "0px"
            }
          }} >
            {
              <Grid container spacing={0.8} className="mt-0 " >
                {favoriteItApp.map((item, i) => {
                  return (
                    <Grid item xs={6} md={6} lg={12} xxl={12} p={"3px"} key={i} className='d-flex align-items-center justify-content-center'>
                      <ItAppLinkCard
                        screenId={screenId}
                        nameAbb={item.ItAppNameAbb}
                        nameOfficial={item.ItAppNameOfficial}
                        link={item.ItAppLink}
                        logoEncodeBase64Data={item.LogoEncodeBase64Data}
                        logoFileExtension={item.LogoFileExtension}
                        controlSettings={controlSettings}
                        apiRequest={apiRequest}
                        itAppId={item.ItAppId}
                        isHomeView={true}
                      />
                    </Grid>
                  )
                })}
              </Grid>
            }
          </CardContent>
        </Grid>
      </Grid>
    </OutlinedCustomCard>
  )
}